import React, { useState, useEffect } from "react";
import CardFilter from "../card/CardFilter";
import RecentActivityItem from "./RecentActivityItem";
import "./recentActivity.css";
import api from "../../api/config";

const RecentActivity = () => {
  const [filter, setFilter] = useState("Today");
  const [items, setItems] = useState([]);
  const handleFilterChange = (filter) => {
    setFilter(filter);
  };

  // const fetchData = async () => {
  //   await fetch("http://localhost:4500/recentactivity")
  //     .then((res) => res.json())
  //     .then((data) => {
  //       setItems(data);
  //     })
  //     .catch((e) => console.log(e.message));
  // };

  const fetchData = async () => {
    try {
      const response = await api.get("/recentactivity", {
        headers: { auth: `${JSON.parse(sessionStorage.getItem("auth"))}` },
      });
      setItems(response.data.data);
    } catch (err) {
      console.error(`Error:${err.message}`);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="card">
      <CardFilter filterChange={handleFilterChange} />
      <div className="card-body">
        <h5 className="card-title">
          Recent Activity <span>| {filter}</span>
        </h5>
        <div className="activity">
          {items &&
            items.length > 0 &&
            items.map((item) => (
              <RecentActivityItem key={item.id} item={item} />
            ))}
        </div>
      </div>
    </div>
  );
};

export default RecentActivity;
